import { useEffect, useState } from 'react';
import { useAuth } from '@/lib/auth';
import { useFirm } from '@/lib/brand';
import { AlertTriangle } from 'lucide-react';

/**
 * Displays a sticky banner when firm_settings.maintenance_mode is on.
 * Admins see it but can still work; other roles are additionally blocked
 * by the backend middleware (503 on mutations).
 */
export function MaintenanceBanner() {
  const { user } = useAuth();
  const { firm } = useFirm();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!firm) { setVisible(false); return; }
    setVisible(!!firm.maintenance_mode);
  }, [firm]);

  if (!visible || !user) return null;

  const message = firm?.maintenance_message || 'El sistema está en modo mantenimiento.';
  const isAdmin = user.role === 'admin';

  return (
    <div
      className="sticky top-0 z-40 bg-amber-500 text-white px-4 py-2 text-sm font-medium flex items-center justify-center gap-2 shadow"
      role="alert"
      data-testid="maintenance-banner"
    >
      <AlertTriangle className="h-4 w-4" />
      <span>{message}</span>
      {isAdmin && (
        <span className="ml-2 text-xs bg-amber-600 px-2 py-0.5 rounded-full">
          Usted es admin: puede seguir operando
        </span>
      )}
    </div>
  );
}
